// extracted by mini-css-extract-plugin
export var bounce = "_lo-1";
export var generatingText = "_lo-6";
export var lightning = "_lo-4";
export var popup = "_lo-5";
export var progressBar = "_lo-7";
export var progressFill = "_lo-8";
export var progressShimmer = "_lo-9";
export var progressText = "_lo-a";
export var shimmer = "_lo-3";
export var uploadIcon = "_lo-0";
export var uploadingText = "_lo-2";